export const numberFormat = ( value ) => {
    if(!value) return;
    return value.toLocaleString('en-IN');
}